import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import type { SxProps } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import { InfoIcon } from '@phosphor-icons/react/Info';

type TextWithInfoProps = {
  children: string;
  containerSx?: SxProps;
  tooltip: string;
} & TypographyProps;

export const TextWithInfo = ({ children, tooltip, containerSx, key, ...rest }: TextWithInfoProps) => (
  <Stack
    direction="row"
    key={key}
    spacing={1.5}
    sx={[
      {
        alignItems: 'center',
      },
      ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
    ]}
  >
    <Typography {...rest}>{children}</Typography>

    <Tooltip placement="right" title={tooltip}>
      <IconButton size="small">
        <InfoIcon />
      </IconButton>
    </Tooltip>
  </Stack>
);
